import {useQuery} from '@tanstack/react-query'

import {listPaymentTerms} from './api'
import {settingsKeys} from './query-keys'

export function usePaymentTerms() {
    return useQuery({
        queryKey: settingsKeys.paymentTerms(),
        queryFn: listPaymentTerms,
        staleTime: Infinity,
    })
}
